import { BaseEnvironment } from 'src/modules/base/environment.contract';
export const environment: BaseEnvironment & Record<string, any> = {
  production: true,
  showLog: false,
  // false: console.* receives text snapshots instead of live objects (see src/console-guard.ts)
  liveConsoleObjects: false,
  firebase: {
    apiKey: "AIzaSyBkZjSaHEMe1aa4uEM1KNYb-WSrAOmDVt8",
    authDomain: "kxfcm-887f2.firebaseapp.com",
    databaseURL: "https://kxfcm-887f2.firebaseio.com",
    projectId: "kxfcm-887f2",
    storageBucket: "kxfcm-887f2.appspot.com",
    messagingSenderId: "287001620189",
    appId: "1:287001620189:web:e5b8780a8691c0e4217534"
  },
  nlp:{
    simbo:{
      url:'',
      ws: "",
      deviceId: "",
      authKey: ""
    }
  },
  recaptcha: {
    siteKey: '6LfO2CcUAAAAAAvsfTZ19lFvUgviopQPqzib5uj8',
    v3SiteKey: '6Lc2MngtAAAAAHrhZPfULPFuWndAsgc6aooAdlCJ',
  },
  wcag:"DBcLHHTHl5"
};
